var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIsrael(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_564)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.9998 40C31.0455 40 39.9998 31.0457 39.9998 20C39.9998 8.9543 31.0455 0 19.9998 0C8.95406 0 -0.000244141 8.9543 -0.000244141 20C-0.000244141 31.0457 8.95406 40 19.9998 40Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.5305 15.6523H22.51L19.9998 11.3044L17.4897 15.6523H12.4691L14.9796 20.0001L12.4691 24.3479H17.4897L19.9998 28.6957L22.51 24.3479H27.5305L25.0201 20.0001L27.5305 15.6523ZM23.0838 20.0001L21.5419 22.671H18.4579L16.9158 20.0001L18.4579 17.3291H21.5419L23.0838 20.0001ZM19.9998 14.6581L20.5737 15.6522H19.4261L19.9998 14.6581ZM15.3737 17.3291H16.5215L15.9476 18.3232L15.3737 17.3291ZM15.3737 22.671L15.9477 21.6769L16.5216 22.671H15.3737ZM19.9998 25.3419L19.426 24.3479H20.5737L19.9998 25.3419ZM24.6259 22.671H23.4781L24.0521 21.6769L24.6259 22.671ZM23.4781 17.3291H24.6259L24.052 18.3232L23.4781 17.3291Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.4496 4.3479H7.55007C5.72483 5.80165 4.15952 7.56743 2.9353 9.56532H37.0644C35.8401 7.56751 34.2748 5.80165 32.4496 4.3479V4.3479Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.55007 35.6522H32.4495C34.2748 34.1985 35.8401 32.4327 37.0643 30.4348H2.9353C4.1596 32.4326 5.72491 34.1985 7.55007 35.6522V35.6522Z",
    fill: "#0052B4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_564"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIsrael);
export default __webpack_public_path__ + "static/media/israel.5aec5cd837f9ec97e3ed546a37406f88.svg";
export { ForwardRef as ReactComponent };